// extracted by mini-css-extract-plugin
module.exports = {"lineThrough":"full-price_lineThrough__K0j_g"};